<div
	class="freya-availability-block freya-availability-template"
	[style.background-color]="isOverriddenButNotOverrideType ? 'var(--light-availability-color)' : ''"
>

	<div
		class="name"
		style="white-space: nowrap; font-size: 11px;"
	>
		{{template.name}} - {{type}}{{isOverriddenButNotOverrideType ? ' (Overriden)' : ''}}
	</div>

	<div style="white-space: nowrap; font-size: 11px;">
		<b>Start:</b> {{template.startDate}} <b>End:</b> {{template.endDate || 'Never'}}
	</div>

	<div style="white-space: nowrap; margin-top: 2px;">
		<span
			*ngFor="let zone of template?.zones"
			style="margin-right: 4px; border-radius: 4px; padding: 2px; font-size: 11px;"
			[style.background-color]="zone.color || '#81D4FA'"
			[style.color]="getTextColor(zone.color)"
		>
			{{zone.name}}
		</span>
	</div>
</div>